import React from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const CalendarRequestRelationshipConnector = ({ className = "" }) => (
  <span
    className={`inline-flex flex-shrink-0 items-center px-0.5 ${className}`}
    aria-hidden="true"
  >
    <span className="h-px w-2.5 bg-gray-300" />
    <ChevronRightIcon className="h-3 w-3 text-gray-400" />
    <span className="h-px w-2.5 bg-gray-300" />
  </span>
);

export default CalendarRequestRelationshipConnector;
